export default __webpack_public_path__ + "static/media/How did you get my information.7114d708.mp3";